class xe extends Error {
  code;
  errorData;
  constructor(t, n, r) {
    super(t), this.name = "HeError", this.code = n, this.errorData = r;
  }
}
function Je(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: mt } = Object.prototype, { getPrototypeOf: we } = Object, { iterator: re, toStringTag: Ve } = Symbol, se = /* @__PURE__ */ ((e) => (t) => {
  const n = mt.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), P = (e) => (e = e.toLowerCase(), (t) => se(t) === e), oe = (e) => (t) => typeof t === e, { isArray: M } = Array, I = oe("undefined");
function V(e) {
  return e !== null && !I(e) && e.constructor !== null && !I(e.constructor) && T(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const We = P("ArrayBuffer");
function yt(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && We(e.buffer), t;
}
const bt = oe("string"), T = oe("function"), Ke = oe("number"), W = (e) => e !== null && typeof e == "object", wt = (e) => e === !0 || e === !1, Y = (e) => {
  if (se(e) !== "object")
    return !1;
  const t = we(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Ve in e) && !(re in e);
}, Et = (e) => {
  if (!W(e) || V(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, gt = P("Date"), Rt = P("File"), St = P("Blob"), Ot = P("FileList"), Tt = (e) => W(e) && T(e.pipe), At = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || T(e.append) && ((t = se(e)) === "formdata" || // detect form-data instance
  t === "object" && T(e.toString) && e.toString() === "[object FormData]"));
}, Ct = P("URLSearchParams"), [xt, Nt, Pt, Ut] = ["ReadableStream", "Request", "Response", "Headers"].map(P), Ft = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function K(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, s;
  if (typeof e != "object" && (e = [e]), M(e))
    for (r = 0, s = e.length; r < s; r++)
      t.call(null, e[r], r, e);
  else {
    if (V(e))
      return;
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let c;
    for (r = 0; r < o; r++)
      c = i[r], t.call(null, e[c], c, e);
  }
}
function ve(e, t) {
  if (V(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], t === s.toLowerCase())
      return s;
  return null;
}
const k = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Xe = (e) => !I(e) && e !== k;
function he() {
  const { caseless: e, skipUndefined: t } = Xe(this) && this || {}, n = {}, r = (s, i) => {
    const o = e && ve(n, i) || i;
    Y(n[o]) && Y(s) ? n[o] = he(n[o], s) : Y(s) ? n[o] = he({}, s) : M(s) ? n[o] = s.slice() : (!t || !I(s)) && (n[o] = s);
  };
  for (let s = 0, i = arguments.length; s < i; s++)
    arguments[s] && K(arguments[s], r);
  return n;
}
const _t = (e, t, n, { allOwnKeys: r } = {}) => (K(t, (s, i) => {
  n && T(s) ? e[i] = Je(s, n) : e[i] = s;
}, { allOwnKeys: r }), e), Lt = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Bt = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Dt = (e, t, n, r) => {
  let s, i, o;
  const c = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; )
      o = s[i], (!r || r(o, e, t)) && !c[o] && (t[o] = e[o], c[o] = !0);
    e = n !== !1 && we(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, kt = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, jt = (e) => {
  if (!e) return null;
  if (M(e)) return e;
  let t = e.length;
  if (!Ke(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, qt = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && we(Uint8Array)), Ht = (e, t) => {
  const r = (e && e[re]).call(e);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const i = s.value;
    t.call(e, i[0], i[1]);
  }
}, It = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Mt = P("HTMLFormElement"), $t = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, s) {
    return r.toUpperCase() + s;
  }
), Ne = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), zt = P("RegExp"), Ge = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  K(n, (s, i) => {
    let o;
    (o = t(s, i, e)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(e, r);
}, Jt = (e) => {
  Ge(e, (t, n) => {
    if (T(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (T(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Vt = (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return M(e) ? r(e) : r(String(e).split(t)), n;
}, Wt = () => {
}, Kt = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function vt(e) {
  return !!(e && T(e.append) && e[Ve] === "FormData" && e[re]);
}
const Xt = (e) => {
  const t = new Array(10), n = (r, s) => {
    if (W(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (V(r))
        return r;
      if (!("toJSON" in r)) {
        t[s] = r;
        const i = M(r) ? [] : {};
        return K(r, (o, c) => {
          const d = n(o, s + 1);
          !I(d) && (i[c] = d);
        }), t[s] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, Gt = P("AsyncFunction"), Zt = (e) => e && (W(e) || T(e)) && T(e.then) && T(e.catch), Ze = ((e, t) => e ? setImmediate : t ? ((n, r) => (k.addEventListener("message", ({ source: s, data: i }) => {
  s === k && i === n && r.length && r.shift()();
}, !1), (s) => {
  r.push(s), k.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  T(k.postMessage)
), Qt = typeof queueMicrotask < "u" ? queueMicrotask.bind(k) : typeof process < "u" && process.nextTick || Ze, Yt = (e) => e != null && T(e[re]), a = {
  isArray: M,
  isArrayBuffer: We,
  isBuffer: V,
  isFormData: At,
  isArrayBufferView: yt,
  isString: bt,
  isNumber: Ke,
  isBoolean: wt,
  isObject: W,
  isPlainObject: Y,
  isEmptyObject: Et,
  isReadableStream: xt,
  isRequest: Nt,
  isResponse: Pt,
  isHeaders: Ut,
  isUndefined: I,
  isDate: gt,
  isFile: Rt,
  isBlob: St,
  isRegExp: zt,
  isFunction: T,
  isStream: Tt,
  isURLSearchParams: Ct,
  isTypedArray: qt,
  isFileList: Ot,
  forEach: K,
  merge: he,
  extend: _t,
  trim: Ft,
  stripBOM: Lt,
  inherits: Bt,
  toFlatObject: Dt,
  kindOf: se,
  kindOfTest: P,
  endsWith: kt,
  toArray: jt,
  forEachEntry: Ht,
  matchAll: It,
  isHTMLForm: Mt,
  hasOwnProperty: Ne,
  hasOwnProp: Ne,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ge,
  freezeMethods: Jt,
  toObjectSet: Vt,
  toCamelCase: $t,
  noop: Wt,
  toFiniteNumber: Kt,
  findKey: ve,
  global: k,
  isContextDefined: Xe,
  isSpecCompliantForm: vt,
  toJSONObject: Xt,
  isAsyncFn: Gt,
  isThenable: Zt,
  setImmediate: Ze,
  asap: Qt,
  isIterable: Yt
};
function y(e, t, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
a.inherits(y, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: a.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Qe = y.prototype, Ye = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Ye[e] = { value: e };
});
Object.defineProperties(y, Ye);
Object.defineProperty(Qe, "isAxiosError", { value: !0 });
y.from = (e, t, n, r, s, i) => {
  const o = Object.create(Qe);
  a.toFlatObject(e, o, function(l) {
    return l !== Error.prototype;
  }, (f) => f !== "isAxiosError");
  const c = e && e.message ? e.message : "Error", d = t == null && e ? e.code : t;
  return y.call(o, c, d, n, r, s), e && o.cause == null && Object.defineProperty(o, "cause", { value: e, configurable: !0 }), o.name = e && e.name || "Error", i && Object.assign(o, i), o;
};
const en = null;
function pe(e) {
  return a.isPlainObject(e) || a.isArray(e);
}
function et(e) {
  return a.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Pe(e, t, n) {
  return e ? e.concat(t).map(function(s, i) {
    return s = et(s), !n && i ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
function tn(e) {
  return a.isArray(e) && !e.some(pe);
}
const nn = a.toFlatObject(a, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function ie(e, t, n) {
  if (!a.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = a.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, h) {
    return !a.isUndefined(h[m]);
  });
  const r = n.metaTokens, s = n.visitor || l, i = n.dots, o = n.indexes, d = (n.Blob || typeof Blob < "u" && Blob) && a.isSpecCompliantForm(t);
  if (!a.isFunction(s))
    throw new TypeError("visitor must be a function");
  function f(u) {
    if (u === null) return "";
    if (a.isDate(u))
      return u.toISOString();
    if (a.isBoolean(u))
      return u.toString();
    if (!d && a.isBlob(u))
      throw new y("Blob is not supported. Use a Buffer instead.");
    return a.isArrayBuffer(u) || a.isTypedArray(u) ? d && typeof Blob == "function" ? new Blob([u]) : Buffer.from(u) : u;
  }
  function l(u, m, h) {
    let E = u;
    if (u && !h && typeof u == "object") {
      if (a.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), u = JSON.stringify(u);
      else if (a.isArray(u) && tn(u) || (a.isFileList(u) || a.endsWith(m, "[]")) && (E = a.toArray(u)))
        return m = et(m), E.forEach(function(g, O) {
          !(a.isUndefined(g) || g === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Pe([m], O, i) : o === null ? m : m + "[]",
            f(g)
          );
        }), !1;
    }
    return pe(u) ? !0 : (t.append(Pe(h, m, i), f(u)), !1);
  }
  const p = [], b = Object.assign(nn, {
    defaultVisitor: l,
    convertValue: f,
    isVisitable: pe
  });
  function R(u, m) {
    if (!a.isUndefined(u)) {
      if (p.indexOf(u) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      p.push(u), a.forEach(u, function(E, C) {
        (!(a.isUndefined(E) || E === null) && s.call(
          t,
          E,
          a.isString(C) ? C.trim() : C,
          m,
          b
        )) === !0 && R(E, m ? m.concat(C) : [C]);
      }), p.pop();
    }
  }
  if (!a.isObject(e))
    throw new TypeError("data must be an object");
  return R(e), t;
}
function Ue(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Ee(e, t) {
  this._pairs = [], e && ie(e, this, t);
}
const tt = Ee.prototype;
tt.append = function(t, n) {
  this._pairs.push([t, n]);
};
tt.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Ue);
  } : Ue;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function rn(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function nt(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || rn;
  a.isFunction(n) && (n = {
    serialize: n
  });
  const s = n && n.serialize;
  let i;
  if (s ? i = s(t, n) : i = a.isURLSearchParams(t) ? t.toString() : new Ee(t, n).toString(r), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Fe {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    a.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const rt = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, sn = typeof URLSearchParams < "u" ? URLSearchParams : Ee, on = typeof FormData < "u" ? FormData : null, an = typeof Blob < "u" ? Blob : null, cn = {
  isBrowser: !0,
  classes: {
    URLSearchParams: sn,
    FormData: on,
    Blob: an
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, ge = typeof window < "u" && typeof document < "u", me = typeof navigator == "object" && navigator || void 0, ln = ge && (!me || ["ReactNative", "NativeScript", "NS"].indexOf(me.product) < 0), un = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", fn = ge && window.location.href || "http://localhost", dn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: ge,
  hasStandardBrowserEnv: ln,
  hasStandardBrowserWebWorkerEnv: un,
  navigator: me,
  origin: fn
}, Symbol.toStringTag, { value: "Module" })), S = {
  ...dn,
  ...cn
};
function hn(e, t) {
  return ie(e, new S.classes.URLSearchParams(), {
    visitor: function(n, r, s, i) {
      return S.isNode && a.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function pn(e) {
  return a.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function mn(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const s = n.length;
  let i;
  for (r = 0; r < s; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function st(e) {
  function t(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const c = Number.isFinite(+o), d = i >= n.length;
    return o = !o && a.isArray(s) ? s.length : o, d ? (a.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !c) : ((!s[o] || !a.isObject(s[o])) && (s[o] = []), t(n, r, s[o], i) && a.isArray(s[o]) && (s[o] = mn(s[o])), !c);
  }
  if (a.isFormData(e) && a.isFunction(e.entries)) {
    const n = {};
    return a.forEachEntry(e, (r, s) => {
      t(pn(r), s, n, 0);
    }), n;
  }
  return null;
}
function yn(e, t, n) {
  if (a.isString(e))
    try {
      return (t || JSON.parse)(e), a.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const v = {
  transitional: rt,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, i = a.isObject(t);
    if (i && a.isHTMLForm(t) && (t = new FormData(t)), a.isFormData(t))
      return s ? JSON.stringify(st(t)) : t;
    if (a.isArrayBuffer(t) || a.isBuffer(t) || a.isStream(t) || a.isFile(t) || a.isBlob(t) || a.isReadableStream(t))
      return t;
    if (a.isArrayBufferView(t))
      return t.buffer;
    if (a.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let c;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return hn(t, this.formSerializer).toString();
      if ((c = a.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return ie(
          c ? { "files[]": t } : t,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return i || s ? (n.setContentType("application/json", !1), yn(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || v.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (a.isResponse(t) || a.isReadableStream(t))
      return t;
    if (t && a.isString(t) && (r && !this.responseType || s)) {
      const o = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (c) {
        if (o)
          throw c.name === "SyntaxError" ? y.from(c, y.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: S.classes.FormData,
    Blob: S.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
a.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  v.headers[e] = {};
});
const bn = a.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), wn = (e) => {
  const t = {};
  let n, r, s;
  return e && e.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), n = o.substring(0, s).trim().toLowerCase(), r = o.substring(s + 1).trim(), !(!n || t[n] && bn[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, _e = Symbol("internals");
function J(e) {
  return e && String(e).trim().toLowerCase();
}
function ee(e) {
  return e === !1 || e == null ? e : a.isArray(e) ? e.map(ee) : String(e);
}
function En(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const gn = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ue(e, t, n, r, s) {
  if (a.isFunction(r))
    return r.call(this, t, n);
  if (s && (t = n), !!a.isString(t)) {
    if (a.isString(r))
      return t.indexOf(r) !== -1;
    if (a.isRegExp(r))
      return r.test(t);
  }
}
function Rn(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Sn(e, t) {
  const n = a.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(s, i, o) {
        return this[r].call(this, t, s, i, o);
      },
      configurable: !0
    });
  });
}
let A = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function i(c, d, f) {
      const l = J(d);
      if (!l)
        throw new Error("header name must be a non-empty string");
      const p = a.findKey(s, l);
      (!p || s[p] === void 0 || f === !0 || f === void 0 && s[p] !== !1) && (s[p || d] = ee(c));
    }
    const o = (c, d) => a.forEach(c, (f, l) => i(f, l, d));
    if (a.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (a.isString(t) && (t = t.trim()) && !gn(t))
      o(wn(t), n);
    else if (a.isObject(t) && a.isIterable(t)) {
      let c = {}, d, f;
      for (const l of t) {
        if (!a.isArray(l))
          throw TypeError("Object iterator must return a key-value pair");
        c[f = l[0]] = (d = c[f]) ? a.isArray(d) ? [...d, l[1]] : [d, l[1]] : l[1];
      }
      o(c, n);
    } else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = J(t), t) {
      const r = a.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return En(s);
        if (a.isFunction(n))
          return n.call(this, s, r);
        if (a.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = J(t), t) {
      const r = a.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || ue(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = J(o), o) {
        const c = a.findKey(r, o);
        c && (!n || ue(r, r[c], c, n)) && (delete r[c], s = !0);
      }
    }
    return a.isArray(t) ? t.forEach(i) : i(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || ue(this, this[i], i, t, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return a.forEach(this, (s, i) => {
      const o = a.findKey(r, i);
      if (o) {
        n[o] = ee(s), delete n[i];
        return;
      }
      const c = t ? Rn(i) : String(i).trim();
      c !== i && delete n[i], n[c] = ee(s), r[c] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return a.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && a.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const r = (this[_e] = this[_e] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const c = J(o);
      r[c] || (Sn(s, o), r[c] = !0);
    }
    return a.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
A.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
a.reduceDescriptors(A.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
a.freezeMethods(A);
function fe(e, t) {
  const n = this || v, r = t || n, s = A.from(r.headers);
  let i = r.data;
  return a.forEach(e, function(c) {
    i = c.call(n, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function ot(e) {
  return !!(e && e.__CANCEL__);
}
function $(e, t, n) {
  y.call(this, e ?? "canceled", y.ERR_CANCELED, t, n), this.name = "CanceledError";
}
a.inherits($, y, {
  __CANCEL__: !0
});
function it(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new y(
    "Request failed with status code " + n.status,
    [y.ERR_BAD_REQUEST, y.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function On(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Tn(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let s = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(d) {
    const f = Date.now(), l = r[i];
    o || (o = f), n[s] = d, r[s] = f;
    let p = i, b = 0;
    for (; p !== s; )
      b += n[p++], p = p % e;
    if (s = (s + 1) % e, s === i && (i = (i + 1) % e), f - o < t)
      return;
    const R = l && f - l;
    return R ? Math.round(b * 1e3 / R) : void 0;
  };
}
function An(e, t) {
  let n = 0, r = 1e3 / t, s, i;
  const o = (f, l = Date.now()) => {
    n = l, s = null, i && (clearTimeout(i), i = null), e(...f);
  };
  return [(...f) => {
    const l = Date.now(), p = l - n;
    p >= r ? o(f, l) : (s = f, i || (i = setTimeout(() => {
      i = null, o(s);
    }, r - p)));
  }, () => s && o(s)];
}
const ne = (e, t, n = 3) => {
  let r = 0;
  const s = Tn(50, 250);
  return An((i) => {
    const o = i.loaded, c = i.lengthComputable ? i.total : void 0, d = o - r, f = s(d), l = o <= c;
    r = o;
    const p = {
      loaded: o,
      total: c,
      progress: c ? o / c : void 0,
      bytes: d,
      rate: f || void 0,
      estimated: f && c && l ? (c - o) / f : void 0,
      event: i,
      lengthComputable: c != null,
      [t ? "download" : "upload"]: !0
    };
    e(p);
  }, n);
}, Le = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, Be = (e) => (...t) => a.asap(() => e(...t)), Cn = S.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, S.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(S.origin),
  S.navigator && /(msie|trident)/i.test(S.navigator.userAgent)
) : () => !0, xn = S.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, s, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      a.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), a.isString(r) && o.push("path=" + r), a.isString(s) && o.push("domain=" + s), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Nn(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Pn(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function at(e, t, n) {
  let r = !Nn(t);
  return e && (r || n == !1) ? Pn(e, t) : t;
}
const De = (e) => e instanceof A ? { ...e } : e;
function q(e, t) {
  t = t || {};
  const n = {};
  function r(f, l, p, b) {
    return a.isPlainObject(f) && a.isPlainObject(l) ? a.merge.call({ caseless: b }, f, l) : a.isPlainObject(l) ? a.merge({}, l) : a.isArray(l) ? l.slice() : l;
  }
  function s(f, l, p, b) {
    if (a.isUndefined(l)) {
      if (!a.isUndefined(f))
        return r(void 0, f, p, b);
    } else return r(f, l, p, b);
  }
  function i(f, l) {
    if (!a.isUndefined(l))
      return r(void 0, l);
  }
  function o(f, l) {
    if (a.isUndefined(l)) {
      if (!a.isUndefined(f))
        return r(void 0, f);
    } else return r(void 0, l);
  }
  function c(f, l, p) {
    if (p in t)
      return r(f, l);
    if (p in e)
      return r(void 0, f);
  }
  const d = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: c,
    headers: (f, l, p) => s(De(f), De(l), p, !0)
  };
  return a.forEach(Object.keys({ ...e, ...t }), function(l) {
    const p = d[l] || s, b = p(e[l], t[l], l);
    a.isUndefined(b) && p !== c || (n[l] = b);
  }), n;
}
const ct = (e) => {
  const t = q({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: c } = t;
  if (t.headers = o = A.from(o), t.url = nt(at(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), c && o.set(
    "Authorization",
    "Basic " + btoa((c.username || "") + ":" + (c.password ? unescape(encodeURIComponent(c.password)) : ""))
  ), a.isFormData(n)) {
    if (S.hasStandardBrowserEnv || S.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if (a.isFunction(n.getHeaders)) {
      const d = n.getHeaders(), f = ["content-type", "content-length"];
      Object.entries(d).forEach(([l, p]) => {
        f.includes(l.toLowerCase()) && o.set(l, p);
      });
    }
  }
  if (S.hasStandardBrowserEnv && (r && a.isFunction(r) && (r = r(t)), r || r !== !1 && Cn(t.url))) {
    const d = s && i && xn.read(i);
    d && o.set(s, d);
  }
  return t;
}, Un = typeof XMLHttpRequest < "u", Fn = Un && function(e) {
  return new Promise(function(n, r) {
    const s = ct(e);
    let i = s.data;
    const o = A.from(s.headers).normalize();
    let { responseType: c, onUploadProgress: d, onDownloadProgress: f } = s, l, p, b, R, u;
    function m() {
      R && R(), u && u(), s.cancelToken && s.cancelToken.unsubscribe(l), s.signal && s.signal.removeEventListener("abort", l);
    }
    let h = new XMLHttpRequest();
    h.open(s.method.toUpperCase(), s.url, !0), h.timeout = s.timeout;
    function E() {
      if (!h)
        return;
      const g = A.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), N = {
        data: !c || c === "text" || c === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: g,
        config: e,
        request: h
      };
      it(function(x) {
        n(x), m();
      }, function(x) {
        r(x), m();
      }, N), h = null;
    }
    "onloadend" in h ? h.onloadend = E : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(E);
    }, h.onabort = function() {
      h && (r(new y("Request aborted", y.ECONNABORTED, e, h)), h = null);
    }, h.onerror = function(O) {
      const N = O && O.message ? O.message : "Network Error", B = new y(N, y.ERR_NETWORK, e, h);
      B.event = O || null, r(B), h = null;
    }, h.ontimeout = function() {
      let O = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const N = s.transitional || rt;
      s.timeoutErrorMessage && (O = s.timeoutErrorMessage), r(new y(
        O,
        N.clarifyTimeoutError ? y.ETIMEDOUT : y.ECONNABORTED,
        e,
        h
      )), h = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in h && a.forEach(o.toJSON(), function(O, N) {
      h.setRequestHeader(N, O);
    }), a.isUndefined(s.withCredentials) || (h.withCredentials = !!s.withCredentials), c && c !== "json" && (h.responseType = s.responseType), f && ([b, u] = ne(f, !0), h.addEventListener("progress", b)), d && h.upload && ([p, R] = ne(d), h.upload.addEventListener("progress", p), h.upload.addEventListener("loadend", R)), (s.cancelToken || s.signal) && (l = (g) => {
      h && (r(!g || g.type ? new $(null, e, h) : g), h.abort(), h = null);
    }, s.cancelToken && s.cancelToken.subscribe(l), s.signal && (s.signal.aborted ? l() : s.signal.addEventListener("abort", l)));
    const C = On(s.url);
    if (C && S.protocols.indexOf(C) === -1) {
      r(new y("Unsupported protocol " + C + ":", y.ERR_BAD_REQUEST, e));
      return;
    }
    h.send(i || null);
  });
}, _n = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), s;
    const i = function(f) {
      if (!s) {
        s = !0, c();
        const l = f instanceof Error ? f : this.reason;
        r.abort(l instanceof y ? l : new $(l instanceof Error ? l.message : l));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new y(`timeout ${t} of ms exceeded`, y.ETIMEDOUT));
    }, t);
    const c = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((f) => {
        f.unsubscribe ? f.unsubscribe(i) : f.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((f) => f.addEventListener("abort", i));
    const { signal: d } = r;
    return d.unsubscribe = () => a.asap(c), d;
  }
}, Ln = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, s;
  for (; r < n; )
    s = r + t, yield e.slice(r, s), r = s;
}, Bn = async function* (e, t) {
  for await (const n of Dn(e))
    yield* Ln(n, t);
}, Dn = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, ke = (e, t, n, r) => {
  const s = Bn(e, t);
  let i = 0, o, c = (d) => {
    o || (o = !0, r && r(d));
  };
  return new ReadableStream({
    async pull(d) {
      try {
        const { done: f, value: l } = await s.next();
        if (f) {
          c(), d.close();
          return;
        }
        let p = l.byteLength;
        if (n) {
          let b = i += p;
          n(b);
        }
        d.enqueue(new Uint8Array(l));
      } catch (f) {
        throw c(f), f;
      }
    },
    cancel(d) {
      return c(d), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, je = 64 * 1024, { isFunction: Q } = a, kn = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(a.global), {
  ReadableStream: qe,
  TextEncoder: He
} = a.global, Ie = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, jn = (e) => {
  e = a.merge.call({
    skipUndefined: !0
  }, kn, e);
  const { fetch: t, Request: n, Response: r } = e, s = t ? Q(t) : typeof fetch == "function", i = Q(n), o = Q(r);
  if (!s)
    return !1;
  const c = s && Q(qe), d = s && (typeof He == "function" ? /* @__PURE__ */ ((u) => (m) => u.encode(m))(new He()) : async (u) => new Uint8Array(await new n(u).arrayBuffer())), f = i && c && Ie(() => {
    let u = !1;
    const m = new n(S.origin, {
      body: new qe(),
      method: "POST",
      get duplex() {
        return u = !0, "half";
      }
    }).headers.has("Content-Type");
    return u && !m;
  }), l = o && c && Ie(() => a.isReadableStream(new r("").body)), p = {
    stream: l && ((u) => u.body)
  };
  s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((u) => {
    !p[u] && (p[u] = (m, h) => {
      let E = m && m[u];
      if (E)
        return E.call(m);
      throw new y(`Response type '${u}' is not supported`, y.ERR_NOT_SUPPORT, h);
    });
  });
  const b = async (u) => {
    if (u == null)
      return 0;
    if (a.isBlob(u))
      return u.size;
    if (a.isSpecCompliantForm(u))
      return (await new n(S.origin, {
        method: "POST",
        body: u
      }).arrayBuffer()).byteLength;
    if (a.isArrayBufferView(u) || a.isArrayBuffer(u))
      return u.byteLength;
    if (a.isURLSearchParams(u) && (u = u + ""), a.isString(u))
      return (await d(u)).byteLength;
  }, R = async (u, m) => {
    const h = a.toFiniteNumber(u.getContentLength());
    return h ?? b(m);
  };
  return async (u) => {
    let {
      url: m,
      method: h,
      data: E,
      signal: C,
      cancelToken: g,
      timeout: O,
      onDownloadProgress: N,
      onUploadProgress: B,
      responseType: x,
      headers: ce,
      withCredentials: X = "same-origin",
      fetchOptions: Re
    } = ct(u), Se = t || fetch;
    x = x ? (x + "").toLowerCase() : "text";
    let G = _n([C, g && g.toAbortSignal()], O), z = null;
    const D = G && G.unsubscribe && (() => {
      G.unsubscribe();
    });
    let Oe;
    try {
      if (B && f && h !== "get" && h !== "head" && (Oe = await R(ce, E)) !== 0) {
        let L = new n(m, {
          method: "POST",
          body: E,
          duplex: "half"
        }), H;
        if (a.isFormData(E) && (H = L.headers.get("content-type")) && ce.setContentType(H), L.body) {
          const [le, Z] = Le(
            Oe,
            ne(Be(B))
          );
          E = ke(L.body, je, le, Z);
        }
      }
      a.isString(X) || (X = X ? "include" : "omit");
      const U = i && "credentials" in n.prototype, Te = {
        ...Re,
        signal: G,
        method: h.toUpperCase(),
        headers: ce.normalize().toJSON(),
        body: E,
        duplex: "half",
        credentials: U ? X : void 0
      };
      z = i && new n(m, Te);
      let _ = await (i ? Se(z, Re) : Se(m, Te));
      const Ae = l && (x === "stream" || x === "response");
      if (l && (N || Ae && D)) {
        const L = {};
        ["status", "statusText", "headers"].forEach((Ce) => {
          L[Ce] = _[Ce];
        });
        const H = a.toFiniteNumber(_.headers.get("content-length")), [le, Z] = N && Le(
          H,
          ne(Be(N), !0)
        ) || [];
        _ = new r(
          ke(_.body, je, le, () => {
            Z && Z(), D && D();
          }),
          L
        );
      }
      x = x || "text";
      let pt = await p[a.findKey(p, x) || "text"](_, u);
      return !Ae && D && D(), await new Promise((L, H) => {
        it(L, H, {
          data: pt,
          headers: A.from(_.headers),
          status: _.status,
          statusText: _.statusText,
          config: u,
          request: z
        });
      });
    } catch (U) {
      throw D && D(), U && U.name === "TypeError" && /Load failed|fetch/i.test(U.message) ? Object.assign(
        new y("Network Error", y.ERR_NETWORK, u, z),
        {
          cause: U.cause || U
        }
      ) : y.from(U, U && U.code, u, z);
    }
  };
}, qn = /* @__PURE__ */ new Map(), lt = (e) => {
  let t = e ? e.env : {};
  const { fetch: n, Request: r, Response: s } = t, i = [
    r,
    s,
    n
  ];
  let o = i.length, c = o, d, f, l = qn;
  for (; c--; )
    d = i[c], f = l.get(d), f === void 0 && l.set(d, f = c ? /* @__PURE__ */ new Map() : jn(t)), l = f;
  return f;
};
lt();
const ye = {
  http: en,
  xhr: Fn,
  fetch: {
    get: lt
  }
};
a.forEach(ye, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Me = (e) => `- ${e}`, Hn = (e) => a.isFunction(e) || e === null || e === !1, ut = {
  getAdapter: (e, t) => {
    e = a.isArray(e) ? e : [e];
    const { length: n } = e;
    let r, s;
    const i = {};
    for (let o = 0; o < n; o++) {
      r = e[o];
      let c;
      if (s = r, !Hn(r) && (s = ye[(c = String(r)).toLowerCase()], s === void 0))
        throw new y(`Unknown adapter '${c}'`);
      if (s && (a.isFunction(s) || (s = s.get(t))))
        break;
      i[c || "#" + o] = s;
    }
    if (!s) {
      const o = Object.entries(i).map(
        ([d, f]) => `adapter ${d} ` + (f === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let c = n ? o.length > 1 ? `since :
` + o.map(Me).join(`
`) : " " + Me(o[0]) : "as no adapter specified";
      throw new y(
        "There is no suitable adapter to dispatch the request " + c,
        "ERR_NOT_SUPPORT"
      );
    }
    return s;
  },
  adapters: ye
};
function de(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new $(null, e);
}
function $e(e) {
  return de(e), e.headers = A.from(e.headers), e.data = fe.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), ut.getAdapter(e.adapter || v.adapter, e)(e).then(function(r) {
    return de(e), r.data = fe.call(
      e,
      e.transformResponse,
      r
    ), r.headers = A.from(r.headers), r;
  }, function(r) {
    return ot(r) || (de(e), r && r.response && (r.response.data = fe.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = A.from(r.response.headers))), Promise.reject(r);
  });
}
const ft = "1.12.2", ae = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ae[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ze = {};
ae.transitional = function(t, n, r) {
  function s(i, o) {
    return "[Axios v" + ft + "] Transitional option '" + i + "'" + o + (r ? ". " + r : "");
  }
  return (i, o, c) => {
    if (t === !1)
      throw new y(
        s(o, " has been removed" + (n ? " in " + n : "")),
        y.ERR_DEPRECATED
      );
    return n && !ze[o] && (ze[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, o, c) : !0;
  };
};
ae.spelling = function(t) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${t}`), !0);
};
function In(e, t, n) {
  if (typeof e != "object")
    throw new y("options must be an object", y.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = t[i];
    if (o) {
      const c = e[i], d = c === void 0 || o(c, i, e);
      if (d !== !0)
        throw new y("option " + i + " must be " + d, y.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new y("Unknown option " + i, y.ERR_BAD_OPTION);
  }
}
const te = {
  assertOptions: In,
  validators: ae
}, F = te.validators;
let j = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Fe(),
      response: new Fe()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = q(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && te.assertOptions(r, {
      silentJSONParsing: F.transitional(F.boolean),
      forcedJSONParsing: F.transitional(F.boolean),
      clarifyTimeoutError: F.transitional(F.boolean)
    }, !1), s != null && (a.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : te.assertOptions(s, {
      encode: F.function,
      serialize: F.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), te.assertOptions(n, {
      baseUrl: F.spelling("baseURL"),
      withXsrfToken: F.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && a.merge(
      i.common,
      i[n.method]
    );
    i && a.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (u) => {
        delete i[u];
      }
    ), n.headers = A.concat(o, i);
    const c = [];
    let d = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(n) === !1 || (d = d && m.synchronous, c.unshift(m.fulfilled, m.rejected));
    });
    const f = [];
    this.interceptors.response.forEach(function(m) {
      f.push(m.fulfilled, m.rejected);
    });
    let l, p = 0, b;
    if (!d) {
      const u = [$e.bind(this), void 0];
      for (u.unshift(...c), u.push(...f), b = u.length, l = Promise.resolve(n); p < b; )
        l = l.then(u[p++], u[p++]);
      return l;
    }
    b = c.length;
    let R = n;
    for (; p < b; ) {
      const u = c[p++], m = c[p++];
      try {
        R = u(R);
      } catch (h) {
        m.call(this, h);
        break;
      }
    }
    try {
      l = $e.call(this, R);
    } catch (u) {
      return Promise.reject(u);
    }
    for (p = 0, b = f.length; p < b; )
      l = l.then(f[p++], f[p++]);
    return l;
  }
  getUri(t) {
    t = q(this.defaults, t);
    const n = at(t.baseURL, t.url, t.allowAbsoluteUrls);
    return nt(n, t.params, t.paramsSerializer);
  }
};
a.forEach(["delete", "get", "head", "options"], function(t) {
  j.prototype[t] = function(n, r) {
    return this.request(q(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
a.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, o, c) {
      return this.request(q(c || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  j.prototype[t] = n(), j.prototype[t + "Form"] = n(!0);
});
let Mn = class dt {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((c) => {
        r.subscribe(c), i = c;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, t(function(i, o, c) {
      r.reason || (r.reason = new $(i, o, c), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new dt(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
function $n(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function zn(e) {
  return a.isObject(e) && e.isAxiosError === !0;
}
const be = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(be).forEach(([e, t]) => {
  be[t] = e;
});
function ht(e) {
  const t = new j(e), n = Je(j.prototype.request, t);
  return a.extend(n, j.prototype, t, { allOwnKeys: !0 }), a.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(s) {
    return ht(q(e, s));
  }, n;
}
const w = ht(v);
w.Axios = j;
w.CanceledError = $;
w.CancelToken = Mn;
w.isCancel = ot;
w.VERSION = ft;
w.toFormData = ie;
w.AxiosError = y;
w.Cancel = w.CanceledError;
w.all = function(t) {
  return Promise.all(t);
};
w.spread = $n;
w.isAxiosError = zn;
w.mergeConfig = q;
w.AxiosHeaders = A;
w.formToJSON = (e) => st(a.isHTMLForm(e) ? new FormData(e) : e);
w.getAdapter = ut.getAdapter;
w.HttpStatusCode = be;
w.default = w;
const {
  Axios: vn,
  AxiosError: Jn,
  CanceledError: Xn,
  isCancel: Gn,
  CancelToken: Zn,
  VERSION: Qn,
  all: Yn,
  Cancel: er,
  isAxiosError: tr,
  spread: nr,
  toFormData: rr,
  AxiosHeaders: sr,
  HttpStatusCode: or,
  formToJSON: ir,
  getAdapter: ar,
  mergeConfig: cr
} = w, Vn = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_,+.~#?&/=]*)$/;
class lr {
  baseUrl;
  headers;
  constructor(t, n = {}) {
    this.baseUrl = t, this.headers = n?.headers || {};
  }
  async fetch(t, n = "GET", r = {}) {
    if (!this.baseUrl)
      throw new Error("No base URL set");
    const s = Vn.test(t) ? t : `${this.baseUrl}${t}`;
    s.includes(this.baseUrl) && (r.withCredentials = !0);
    try {
      return (await w(s, {
        ...r,
        method: n,
        data: r.data,
        headers: { ...this.headers, ...r.headers },
        withCredentials: r.withCredentials
      })).data;
    } catch (o) {
      throw o instanceof Jn ? new xe(`${o.code} - ${o.status} - ${s}`, o.status, o.response?.data) : new xe("An error occured while fetching");
    }
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  setBaseUrl(t) {
    this.baseUrl = t;
  }
  async get(t, n = {}) {
    return this.fetch(t, "GET", n);
  }
  async post(t, n = {}) {
    return this.fetch(t, "POST", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async put(t, n = {}) {
    return this.fetch(t, "PUT", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async delete(t, n = {}) {
    return this.fetch(t, "DELETE", n);
  }
  async patch(t, n = {}) {
    return this.fetch(t, "PATCH", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
}
export {
  xe as HeError,
  lr as HeFetch
};
